import React, { useEffect, useRef } from 'react';

export function ScrollToViewportOnLoad({ children }) {
  const elRef = useRef(null);

  useEffect(() => {
    setTimeout(() => {

      elRef.current.scrollIntoView({ behavior: 'smooth', block: 'end' });
    }, 0);
  }, []);

  return (
    <div ref={elRef}>
      {children}
    </div>
  );
}
